import styled, { css } from "styled-components";
import { colors } from "../../../base/styled/variables.styled";
import { typography } from "../../../base/styled/typography.style";
export const InputContainer = styled.div `
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 8px;
`;
export const LabelContainer = styled.div `
	display: flex;
	align-items: center;
	gap: 8px;
`;
export const Label = styled.label.withConfig({
    shouldForwardProp: (prop) => !['disabled'].includes(prop),
}) `
	${typography.body1}
	color: ${(props) => props.disabled ? colors.neutral400 : colors.neutral700};
	margin: 0;
`;
export const StyledInputWrapper = styled.div `
	position: relative;
	display: flex;
	align-items: center;
	width: 100%;
`;
export const RightIconsContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['isMultiline'].includes(prop),
}) `
	position: absolute;
	right: 16px;
	top: ${(props) => (props.isMultiline ? "14px" : "50%")};
	transform: ${(props) => (props.isMultiline ? "none" : "translateY(-50%)")};
	display: flex;
	align-items: center;
	gap: 4px;
	pointer-events: auto;
	z-index: 2;
`;
export const StyledInput = styled.input `
	${typography.body1}
	width: 100%;
	padding: 10px 16px;
	padding-right: ${(props) => (props.hasRightIcons ? "60px" : "16px")};
	border: 2px solid
		${({ error, success }) => error
    ? colors.errorRed
    : success
        ? colors.successGreenLight
        : colors.brand200};
	border-radius: 8px;
  background-color: ${colors.neutral000};
	color: ${typography.body1.color};
	box-sizing: border-box;

	&:hover:not(:disabled):not([error]):not([success]) {
    border-color: ${colors.brand500};
	}

	&:active:not(:disabled):not([error]):not([success]) {
    border-color: ${colors.brand500};
	}

	&:focus {
		border-color: ${({ error, success }) => error
    ? colors.errorRed
    : success
        ? colors.successGreenLight
        : colors.brand500};
		box-shadow: 0 0 0 3px
			${({ error, success }) => error
    ? `${colors.errorRed}20`
    : success
        ? `${colors.successGreenLight}20`
        : colors.brand300};
		outline: none;
	}
	&::placeholder {
    color: ${colors.neutral400};
	}

	&:disabled {
		background-color: ${colors.neutral100};
		border-color: ${colors.neutral300};
		cursor: not-allowed;
		color: ${colors.neutral500};
	}

	&[type="time"] {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
	}
`;
export const StyledTextarea = styled.textarea `
	${typography.body1}
	width: 100%;
	min-height: 120px;
	padding: 10px 16px;
	padding-right: ${(props) => (props.hasRightIcons ? "60px" : "16px")};
	border: 2px solid
		${({ error, success }) => error
    ? colors.errorRed
    : success
        ? colors.successGreenLight
        : colors.brand200};
	border-radius: 8px;
  background-color: ${colors.neutral000};
	color: ${typography.body1.color};
	box-sizing: border-box;
	resize: vertical;

	&:hover:not(:disabled):not([error]):not([success]) {
    border-color: ${colors.brand500};
	}

	&:active:not(:disabled):not([error]):not([success]) {
    border-color: ${colors.brand500};
	}

	&:focus {
		border-color: ${({ error, success }) => error
    ? colors.errorRed
    : success
        ? colors.successGreenLight
        : colors.brand500};
		box-shadow: 0 0 0 3px
			${({ error, success }) => error
    ? `${colors.errorRed}20`
    : success
        ? `${colors.successGreenLight}20`
        : colors.brand300};
		outline: none;
	}

	&::placeholder {
    color: ${colors.neutral400};
	}

	&:disabled {
		background-color: ${colors.neutral100};
		border-color: ${colors.neutral300};
		cursor: not-allowed;
		color: ${colors.neutral500};
	}
`;
export const IconContainer = styled.div `
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${colors.neutral500};
	pointer-events: auto;
	z-index: 1;
`;
export const TooltipButton = styled.button `
	background: none;
	border: none;
	cursor: pointer;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	color: ${colors.neutral500};
	pointer-events: auto;

	svg {
		width: 16px;
		height: 16px;
	}

	&:hover {
    color: ${colors.brand500};
	}
`;
export const SupportText = styled.div.withConfig({
    shouldForwardProp: (prop) => !['isError', 'isSuccess', 'disabled'].includes(prop),
}) `
	${typography.body3}
	color: ${(props) => {
    if (props.disabled)
        return colors.neutral400;
    if (props.isError)
        return colors.errorRedIcon;
    if (props.isSuccess)
        return colors.successGreen;
    return colors.neutral600;
}};
	margin: 0;
	padding-left: 8px;
`;
export const SuggestionsContainer = styled.div `
	display: block;
	box-shadow: 0px 1px 4px 0px #005eb833;
	background-color: ${colors.neutral000};
	border-radius: 8px;
	position: absolute;
	padding: 4px;
	left: 0;
	width: calc(100% - 10px);
	top: 105%;
	z-index: 100;

	.ps-search-bar-autocomplete-scroll {
		max-height: 232px;
		overflow-y: auto;

		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-track {
			background-color: #f1f1f1;
			border: solid 5px transparent;
			border-radius: 100px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #c1c1c1;
			border: solid 5px transparent;
			border-radius: 100px;
		}
	}
`;
export const SuggestionItem = styled.div `
	${css(typography.body2)}
	text-decoration: none;
	padding: 8px 16px;
	display: block;
	width: calc(100% - 32px);
	border-radius: 4px;
	text-align: left;
	cursor: pointer;

	mark {
		color: ${colors.neutral500};
		background-color: transparent;
	}

	&:focus-visible {
		border: 0;
		-webkit-box-shadow: 0 0 0 3px ${colors.brand300};
		-moz-box-shadow: 0 0 0 3px ${colors.brand300};
		box-shadow: 0 0 0 3px ${colors.brand300};
	}

	&:hover {
		background-color: ${colors.brand75};
	}
`;
export const RequiredLabel = styled.span `
	color: ${colors.neutral500};
`;
//# sourceMappingURL=InputText.style.js.map